import { NotificationItemGroup } from './models/notification-item-group';
import { PdsWidget } from './pds-widget';

export class PdsActivityFeedNotification extends PdsWidget {
  is = 'pds-activity-feed-notification';

  notificationGroup: NotificationItemGroup;
  getS3MediaPath: () => string;

  ready(): void {
    this.getS3MediaPath = this.pds.preferences.getS3MediaPath;
  }

  messageKeysUpdated(): void {}
}
